export default __webpack_public_path__ + "static/media/tooth_for_sextant.9934c488.png";